import { iImageVersions } from "../../definitions/Image"
import { iSelectOptionType } from "../../definitions/interfaces"
import { iPackage } from "../../definitions/Package"
import { iUser, iUserBusiness } from "../../definitions/User"
import { iPermission } from "../permissions/types"

export const USER_DATA = "USER_DATA"
export const SET_USER_NAME = "SET_USER_NAME"
export const USER_LOGGEDIN = "USER_LOGGEDIN"
export const USER_LOGGEDOUT = "USER_LOGGEDOUT"
export const INITIAL_USERS = "INITIAL_USERS"
export const SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS"

export type UserState = iUserInitialData & Partial<iUser>

export interface iUserInitialData {
  _id?: string
  name?: string
  isLoggedIn: boolean
  token: string | null
  permissions?: Array<iPermission>
  package?: Partial<iPackage>
  roles?: string[]
}

export type User = UserState & iUser

export interface UserDataAction {
  type: typeof USER_DATA
  payload: iUser
}
export interface SetUserNameAction {
  type: typeof SET_USER_NAME
  payload: string
}

export interface UserLoggedInAction {
  type: typeof USER_LOGGEDIN
  payload: string
}

export interface UserLoginParams {
  email: string
  password: string
}
export interface UserLoggedOutAction {
  type: typeof USER_LOGGEDOUT
}

export interface InitialUsersAction {
  type: typeof INITIAL_USERS
  payload: Array<iSelectOptionType<string>>
}

export interface SetUserPermissionsAction {
  type: typeof SET_USER_PERMISSIONS
  payload: Array<iPermission>
}

export type UserActionTypes =
  | UserDataAction
  | SetUserNameAction
  | UserLoggedInAction
  | UserLoggedOutAction
  | SetUserPermissionsAction
